var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoAppGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Logoapps"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.22238 0.16125H56.7776C60.6773 0.16125 63.8387 3.32262 63.8387 7.22237V56.7776C63.8387 60.6774 60.6773 63.8387 56.7776 63.8387H7.22238C3.32263 63.8387 0.16125 60.6774 0.16125 56.7776V7.22237C0.16125 3.32262 3.32263 0.16125 7.22238 0.16125Z",
    fill: "url(#paint0_linear_823_6995)",
    stroke: "#FFF6FF",
    strokeWidth: 0.322499
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.3095 45.9819C20.3095 45.9722 20.3095 45.9626 20.3111 45.9529C20.5594 45.9529 20.8094 45.9545 21.0577 45.9545C21.1819 45.9545 21.306 45.9545 21.4302 45.9545V45.9835H20.3079L20.3095 45.9819Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M41.9346 45.9529C41.9346 45.9626 41.9346 45.9722 41.9346 45.9803H40.8381C40.8381 45.9706 40.8381 45.9626 40.8381 45.9529C40.9784 45.9529 41.1187 45.9529 41.259 45.9529C41.4831 45.9529 41.7073 45.9529 41.9314 45.9529H41.9346Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M55.6005 33.3127C55.6425 32.8741 55.6634 32.4339 55.6634 31.9872C55.6634 27.3626 53.4075 23.2571 49.9423 20.7046C47.6251 19.0018 44.7629 17.9907 41.6685 17.9907C35.9603 17.9907 31.0374 21.4237 28.8621 26.3354C28.5525 27.0352 29.0588 27.8221 29.8248 27.8221H34.8106C36.2199 25.5098 38.7677 23.9618 41.6685 23.9618C43.1069 23.9618 44.4614 24.3423 45.6305 25.0148C48.0766 26.408 49.7246 29.0525 49.6907 32.0743L49.6875 32.0823L47.3187 35.3331H48.957C47.6864 38.0921 44.8968 40.0094 41.6685 40.0094C40.6527 40.0094 39.682 39.8207 38.7854 39.474C38.5677 39.3902 38.3533 39.2966 38.1453 39.1951C37.8373 39.0999 37.5083 39.0548 37.1665 39.0661C35.6281 39.1128 34.3478 40.3448 34.243 41.8799C34.1688 42.9748 34.6784 43.9568 35.4911 44.5437C35.8716 44.7324 36.2634 44.9033 36.6617 45.0565C38.2162 45.6531 39.9045 45.9804 41.6669 45.9804C48.2314 45.9804 53.7542 41.438 55.2587 35.3331H57.0727L55.5989 33.3111L55.6005 33.3127Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6635 31.987C55.6635 32.4336 55.6441 32.8739 55.6006 33.3125L52.1966 28.6394L49.6875 32.0837C49.6908 32.0531 49.6908 32.0176 49.6908 31.987C49.6908 29.0039 48.0525 26.3965 45.6289 25.0162L49.9407 20.7043C53.4076 23.2553 55.6635 27.3623 55.6635 31.987Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M41.6928 26.5433C38.7549 26.5288 36.212 28.8846 36.2087 31.9951C36.2055 35.0476 38.6726 37.4502 41.6574 37.4534C44.6776 37.4567 47.1221 35.0137 47.1221 31.9951C47.1221 28.9959 44.6824 26.5578 41.6912 26.5433H41.6928Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M34.9202 31.5468V29.1425H34.6154C34.5993 29.1329 34.5703 29.1313 34.5187 29.1313C34.2075 29.1313 33.8946 29.1313 33.5834 29.1313C31.8339 29.1313 30.0827 29.1313 28.3331 29.1313C27.0061 29.1313 25.679 29.1345 24.3519 29.1345C23.8649 29.1345 23.3925 29.2038 22.9506 29.4102C21.9315 29.8843 21.3091 30.6776 21.1414 31.7886C20.8963 33.4108 21.9509 34.8733 23.4924 35.241C23.7617 35.3055 24.0358 35.3329 24.3132 35.3329C25.4661 35.3313 26.6191 35.3329 27.7736 35.3329H27.9075C27.9236 35.3926 27.8881 35.4313 27.8671 35.4716C27.1028 36.9889 25.9467 38.1548 24.397 38.961C24.002 39.1674 23.5875 39.3351 23.1586 39.4561C18.6436 40.7428 14.3818 37.9742 13.3788 33.8478C13.1918 33.0754 13.1225 32.2934 13.1757 31.5032C13.4127 27.9783 15.9314 25.2403 19.0613 24.476C19.8675 24.2792 20.6851 24.2083 21.5123 24.2712C22.4653 24.3438 23.3763 24.5856 24.2406 24.9984C26.0628 25.8692 28.2251 24.8517 28.6556 22.8457C28.9717 21.3784 28.2106 19.9529 26.9109 19.3531C26.1063 18.9822 25.2791 18.6742 24.4196 18.4549C23.7504 18.284 23.0732 18.1598 22.3863 18.0905C22.1734 18.0695 21.9605 18.0469 21.7477 18.0389C21.6251 18.0518 21.5026 18.0421 21.3816 18.026C21.3591 18.0228 21.3365 18.0211 21.3139 18.0195C21.0962 18.0163 20.8802 18.0147 20.6641 18.0115C20.5206 18.0211 20.3755 18.0357 20.232 18.0437C20.1836 18.047 20.1368 18.0421 20.0885 18.0405C18.6808 18.1211 17.3149 18.4098 15.9959 18.9064C11.8212 20.4786 8.64777 23.939 7.43678 28.2395C7.21748 29.02 7.06913 29.815 6.99173 30.6228C6.96432 30.9066 6.9466 31.1904 6.93209 31.4742C6.93048 31.6645 6.92725 31.8564 6.92725 32.0466C6.92725 32.216 6.93048 32.3837 6.93209 32.553C6.94983 33.0238 6.99014 33.4947 7.05625 33.9623C7.21589 35.1039 7.50453 36.2117 7.94635 37.276C9.22345 40.3445 11.3019 42.6795 14.1786 44.279C15.5057 45.0176 16.9505 45.5255 18.4437 45.7948C18.9984 45.8948 19.5563 45.9625 20.1207 45.9883C20.2013 45.9915 20.2803 46.0012 20.361 46.0076C20.6093 46.0076 20.8592 46.0093 21.1075 46.0093C21.2317 46.0093 21.3559 46.0093 21.48 46.0093C21.7864 45.9802 22.0928 45.9689 22.3975 45.9367C23.2489 45.848 24.0858 45.6851 24.9066 45.44C28.6315 44.3323 31.7323 41.7297 33.4641 38.2596C34.0865 37.0131 34.5106 35.7038 34.7412 34.3299C34.896 33.4076 34.9525 32.4804 34.925 31.5484L34.9202 31.5468Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M20.3095 45.9819C20.3095 45.9722 20.3095 45.9626 20.3111 45.9529C20.5594 45.9529 20.8094 45.9545 21.0577 45.9545C21.1819 45.9545 21.306 45.9545 21.4302 45.9545V45.9835H20.3079L20.3095 45.9819Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M41.9346 45.9529C41.9346 45.9626 41.9346 45.9722 41.9346 45.9803H40.8381C40.8381 45.9706 40.8381 45.9626 40.8381 45.9529C40.9784 45.9529 41.1187 45.9529 41.259 45.9529C41.4831 45.9529 41.7073 45.9529 41.9314 45.9529H41.9346Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.84,
    d: "M55.6635 31.987C55.6635 32.4336 55.6441 32.8739 55.6006 33.3125L52.1966 28.6394L49.6875 32.0837C49.6908 32.0531 49.6908 32.0176 49.6908 31.987C49.6908 29.0039 48.0525 26.3965 45.6289 25.0162L49.9407 20.7043C53.4076 23.2553 55.6635 27.3623 55.6635 31.987Z",
    fill: "url(#paint1_linear_823_6995)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_823_6995",
    x1: 63.9984,
    y1: 32,
    x2: 0,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F00A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5900A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#9300A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C200AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#E300AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F700B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_823_6995",
    x1: 47.8961,
    y1: 21.8847,
    x2: 54.7702,
    y2: 33.7914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAppGo);
export default __webpack_public_path__ + "static/media/logo_app_go.9a0dab0ec642aeb1199ecbd73d2dec63.svg";
export { ForwardRef as ReactComponent };